import { QuantitySavingsQuote } from 'editor/src/store/quantitySavings/types';

import getNextQuantitySavingsTier from './getNextQuantitySavingsTier';

/** How far the quantity has moved from its band's threshold towards the next one, 0 to 1. */
function getQuantitySavingsProgress(quote: QuantitySavingsQuote): number {
  const next = getNextQuantitySavingsTier(quote);
  if (!next) {
    return 1;
  }
  const from = quote.tiers[quote.activeTierIndex]?.minimumQuantity ?? 0;
  const span = quote.quantity + next.additionalQuantity - from;
  if (span <= 0) {
    return 0;
  }
  return Math.min(1, Math.max(0, (quote.quantity - from) / span));
}

export default getQuantitySavingsProgress;
